import { css } from '@emotion/react';
import { Close } from '@mui/icons-material';
import { Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import QRCode from 'react-qr-code';

import { createEventAccessCodeQRCode } from '@jebel/utils';

export type EventCodeModalProps = {
  eventId: string | null | undefined;
  show: boolean;

  onClose?: () => void;
};

export function EventCodeModal({ eventId, show, onClose }: EventCodeModalProps) {
  // Don't render if no event ID
  if (!eventId) {
    return null;
  }

  const qrCodeValue = createEventAccessCodeQRCode({ id: eventId });

  return (
    <Dialog open={show} onClose={onClose} maxWidth="xs" fullWidth css={modalCSS}>
      <DialogTitle css={headerCSS}>
        <Typography variant="h6">Event Attendance Code</Typography>

        <IconButton onClick={onClose} size="small">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent css={contentCSS}>
        <QRCode value={qrCodeValue} size={256} />

        <Typography variant="body2" color="textSecondary" align="center">
          Show this QR code to attendees so they can mark their attendance.
        </Typography>
      </DialogContent>
    </Dialog>
  );
}

const modalCSS = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const headerCSS = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const contentCSS = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;
